export default __webpack_public_path__ + "static/3-5_HSR_Icon-7ea7ed9f7108e3aefdd9c783312268f1.png";